import React from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import { observer } from 'mobx-react';
import { Autocomplete } from '@material-ui/lab';

import { loc } from '../../lib/loc';
import { RegisterLoc } from '../../loc/register';
import { useStores } from '../../hooks/use-stores';

const CityAutocomplete = observer(() => {
    const { RegisterStore: { cities, selectedCity, setSelectedCity } = {} } = useStores();

    const classes = useStyles();

    return (
        <Autocomplete
            required
            id="city"
            value={selectedCity || ''}
            onChange={(e, value) => setSelectedCity(value)}
            getOptionLabel={option => (option ? option.title : '')}
            options={cities}
            classes={{ root: classes.root, inputRoot: classes.inputRoot }}
            renderInput={params => <TextField {...params} placeholder={loc(RegisterLoc.form.city)} required />}
        />
    );
});

const useStyles = makeStyles({
    root: {
        marginBottom: 30,
    },
    inputRoot: {
        '&::before': {
            borderBottom: '1px solid #afafaf !important',
            '&:hover': { borderBottom: '1px solid #afafaf' },
        },

        '&::after': {
            transition: 'none',
            borderBottom: '1px solid #cc0514',
        },
        '&::placeholder': {
            color: '#999999',
        },
    },
});

export default CityAutocomplete;
